import { NgModule } from '@angular/core';
import { TimeLimitRollerShutterDriveService } from './time-limit-roller-shutter-drive.service';
import { TimeLimitRollerShutterProfileService } from './time-limit-roller-shutter-profile.service';
import { TimeLimitRollerShutterSystemService } from './time-limit-roller-shutter-system.service';
import { TimeLimitRollerShutterColorGroupService } from './time-limit-roller-shutter-color-group.service';

@NgModule({
    providers: [
        TimeLimitRollerShutterDriveService,
        TimeLimitRollerShutterProfileService,
        TimeLimitRollerShutterSystemService,
        TimeLimitRollerShutterColorGroupService,
    ],
})
export class ShutterTimeLimitModule {}
